export enum GestaoAgendamentoTypes {
  'LOAD_REQUEST' = '@gestaoAgendamento/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@gestaoAgendamento/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@gestaoAgendamento/LOAD_FAILURE',

  'CLEAN_MOVIENTRADA' = '@GestaoAgendamento/CLEAN_MOVIENTRADA',
}

export interface Pagination {
  total: number;
  pageSize: number;
  current: number;
  showSizeChanger: boolean; 
  pageSizeOptions: string[]
}
export interface IGestaoAgendamento {
  nuNota: number;
  numNota: number;
  ocorrencia: boolean;
  dtLancamento: Date;
  status: string;
  emissorNF: string;
  proprietarioMercadoria: string;
  pagadorArmazenagem: string;
  tempoArmazenagemContratado: number;
  tempoRestante: number;
  pesoBruto: number;
  vlrMercadoria: number;
  itensNota: string;
}

export interface IFiltroMovi {
  numNota: number;
  periodoLacamentoInicio: Date;
  periodoLacamentoFim: Date;
  periodoEmissaoInicio: Date;
  periodoEmissaoFim: Date;
  produto: string;
  remetente: string;
  movimentaEstoque: boolean;
  etapa: string;
}

export interface EtapaNota {
  valor: string;
  opcao: string;
}

export interface GestaoAgendamentoState {
  readonly data?: IGestaoAgendamento[];
  readonly loading: boolean;
  readonly error: boolean;
  readonly pagination: Pagination;
}